import { useEffect } from 'react';
import { useLocation, useNavigate, useRouteError } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import SomethingWentWrong from '@app/components/SomethingWentWrong';

const sectionTagForPathname = pathname => {
  if (pathname === '/create-account') {
    return 'CreateAccount';
  }
  if (pathname.startsWith('/signin/')) {
    return 'SignIn';
  }
  return undefined;
};

const RootErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (error) {
      const section = sectionTagForPathname(location.pathname);
      Sentry.captureException(error, {
        tags: {
          source: 'RootErrorBoundary',
          ...(section && { section }),
          pathname: location.pathname,
        },
        extra: { pathname: location.pathname },
      });
    }
  }, [error, location.pathname]);

  const onReset = () => {
    navigate('/');
    window.location.reload();
  };

  return <SomethingWentWrong onClick={onReset} />;
};

export default RootErrorBoundary;
